import { render, staticRenderFns } from "./ProjectEditor.vue?vue&type=template&id=3e136e36&"
import script from "./ProjectEditor.vue?vue&type=script&lang=js&"
export * from "./ProjectEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectEditor.vue"
export default component.exports